module.exports = __webpack_public_path__ + "resources/img/img-secuve-tos-04-jp.08f86ae7170a0a388349ea63c37c7ddf.png";